import VendorTagsEditorConnected from "./VendorTagsEditorConnected";

/** Custom Tags cell for My Vendors table rows. */
export default function MyVendorTableTagsCell({ providerId, sponsorId = null, className = "" }) {
  return (
    <VendorTagsEditorConnected
      providerId={providerId}
      sponsorId={sponsorId}
      size="xs"
      className={className}
    />
  );
}
